module.exports = __webpack_public_path__ + "static/beer_bottles-a2d8f28f2d4b341b2ced06db98a87fc1.svg";